import { render, staticRenderFns } from "./exchangeAgentForm.vue?vue&type=template&id=4ae7e3e7&"
import script from "./exchangeAgentForm.vue?vue&type=script&lang=js&"
export * from "./exchangeAgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae7e3e7')) {
      api.createRecord('4ae7e3e7', component.options)
    } else {
      api.reload('4ae7e3e7', component.options)
    }
    module.hot.accept("./exchangeAgentForm.vue?vue&type=template&id=4ae7e3e7&", function () {
      api.rerender('4ae7e3e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/exchangeAgentForm.vue"
export default component.exports